import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Input, Checkbox, message } from 'antd';
import { createInternalReportSchedule } from '../../services/internalReportingService';

const ScheduleFormModal = ({ visible, onClose, onSuccess, schedule }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      if (schedule) {
        form.setFieldsValue(schedule);
      } else {
        form.resetFields();
        form.setFieldsValue({ status: 'Active' });
      }
    }
  }, [visible, schedule, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const res = await createInternalReportSchedule(values);
      if (res?.status) {
        message.success(res.message);
        onSuccess && onSuccess();
      }
    } catch (err) {
      console.error('Validation failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={schedule ? 'Edit Schedule' : 'Create Report Schedule'}
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={schedule ? 'Update' : 'Create'}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="reportName"
          label="Report Description"
          rules={[{ required: true, message: 'Please enter a description' }]}
        >
          <Input placeholder="e.g. Weekly Branch Performance Summary" />
        </Form.Item>

        <Form.Item
          name="reportType"
          label="Report Category"
          rules={[{ required: true, message: 'Please select category' }]}
        >
          <Select placeholder="Select category">
            <Select.Option value="Financial">Financial</Select.Option>
            <Select.Option value="Operational">Operational</Select.Option>
            <Select.Option value="Performance">Performance</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="frequency"
          label="Generation Frequency"
          rules={[{ required: true, message: 'Please select frequency' }]}
        >
          <Select placeholder="Select interval">
            <Select.Option value="Daily">Daily (at 00:00)</Select.Option>
            <Select.Option value="Weekly">Weekly (Every Monday)</Select.Option>
            <Select.Option value="Monthly">Monthly (1st of Month)</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="status" label="Status">
          <Select>
            <Select.Option value="Active">Active</Select.Option>
            <Select.Option value="Paused">Paused</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label="Filters for Scheduled Report">
          <div style={{ padding: '8px', background: '#f5f5f5', borderRadius: '4px' }}>
            <Checkbox checked disabled>Apply default branch filters</Checkbox>
            <br />
            <Checkbox checked disabled>Apply default product filters</Checkbox>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ScheduleFormModal;
